<div class="relative flex flex-col h-full min-h-0 bg-white overflow-y-auto md:overflow-hidden" [@rise]>

  <div class="relative flex-1 min-h-0 w-full h-full" [@stageSwitch]="stage()">
    @switch (stage()) {

      @case ('choose_billing_state') {
        @if (choosePackage(); as choosePackage) {
          <app-purchase-flow-stage-choose-billing
            [choosePackage]="choosePackage"
            (continueToInvoice)="onContinueToInvoice($event)">
          </app-purchase-flow-stage-choose-billing>
        }
      }

      @case ('invoice_state') {
        @if (invoiceUuid(); as invoiceUuid) {
          <app-invoice-plan-upgrade class="h-full flex flex-col min-h-0" (outputInvoiceStatus)="invoiceStatus.set($event)" [invoiceUuid]="invoiceUuid"></app-invoice-plan-upgrade>
        }
      }
    }

  </div>
</div>
